var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-snotify'),_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[(_vm.$store.state.loading)?_c('Loading',{staticClass:"maxHeight"}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }